// libs
import type * as z from 'zod'
// types
import type { IChartDataInput } from 'types/graphql'
// schemas
import type { ChartConfigSchema, ChartConfig as ChartSchemaConfig } from 'schemas/chartConfig'

// The enums of the config live with its schema, which the backend shares
export {
  ChartType,
  ChartSortBy,
  ChartSortOrder,
  ChartValueMode,
  ChartAlign,
  ChartSide,
  ChartLegendType,
  ChartLegendAlign,
  ChartLegendIcon,
  ChartTooltipTrigger,
  ChartAxisPointer,
  ChartPalette,
  ChartLabelPosition,
  ChartLabelFormat,
  ChartNameLocation,
  ChartLabelInterval,
  ChartScale,
  ChartStack,
  ChartLineStep,
  ChartSymbol,
  ChartPieVariant,
  ChartSelectedMode
} from 'schemas/chartConfig'

// chartData's key of a SWITCH field
export enum ChartSwitchKey {
  True = 'true',
  False = 'false'
}

// What the server computes, stored as Chart.query: the chartPreview input, the server checks it
export type ChartQuery = IChartDataInput

// Chart.config as parsed: every default filled in
export type ChartStoredConfig = ChartSchemaConfig

export type ChartTransform = ChartStoredConfig['transform']
export type ChartDisplay = ChartStoredConfig['display']
export type ChartNumberFormat = ChartDisplay['number']

// A chart as the app draws and edits it: the config with its query back inside
export type ChartConfig = ChartStoredConfig & { query: ChartQuery }

// A config as stored or proposed: anything may be missing, the type too (the schema requires it, the app fills it in)
export type ChartConfigInput = Partial<z.input<typeof ChartConfigSchema>> & { query?: Partial<ChartQuery> }
